import { ref } from "vue";
const rootClassList = document.documentElement.classList;
const initialAdaClassesJson = localStorage.getItem('AdaClasses');
const initialAdaClasses = initialAdaClassesJson && JSON.parse(initialAdaClassesJson) || [];
if (initialAdaClasses.length > 0)
    rootClassList.add(...initialAdaClasses);
const adaClasses = ref(initialAdaClasses);
export function useAdaClasses() {
    function setAdaClasses(newAdaClasses) {
        if (adaClasses.value.length > 0)
            rootClassList.remove(...adaClasses.value);
        if (newAdaClasses.length > 0)
            rootClassList.add(...newAdaClasses);
        adaClasses.value = newAdaClasses;
        localStorage.setItem('AdaClasses', JSON.stringify(newAdaClasses));
    }
    return {
        adaClasses,
        setAdaClasses
    };
}
